import { ref } from 'vue';
import { defineStore } from 'pinia';

/** Client相關資料 Store */
export const useClientStore = defineStore('ClientStore', () => {
    /** 清除資料 */
    const $reset = () => {
        routeInitState.value = false;
        isLogin.value = false;
        isMobile.value = false;
        isWebView.value = false;
        isLoaded.value = false;
        currentAlertId.value = '';
        confirmedAlertId.value = '';
    };

    /** 使用者確認重新流程 */
    let routeInitState = ref<Boolean>(false);
    let isLogin = ref<Boolean>(false);
    let isMobile = ref<Boolean>(false);
    let isWebView = ref<Boolean>(false);
    const isLoaded = ref(false); // 用於標記是否完成加載
    const currentAlertId = ref<string>('');
    const confirmedAlertId = ref<string>('');

    /** App Route 是否開啟第一個request  */
    const setRouteInit = (_initState: boolean) => {
        routeInitState.value = _initState;
    };

    /** Set使用者是否登入 */
    const setLoginState = (_isLogin: boolean) => {
        isLogin.value = _isLogin;
    };

    /** Set使用者是否登入 */
    const setIsMobileState = (_isMobile: boolean) => {
        isMobile.value = _isMobile;
    };

    /** Set使用者是否登入 */
    const setIsWebViewState = (_isWebView: boolean) => {
        isWebView.value = _isWebView;
    };

    const setIsLoaded = (_isLoaded: boolean) => {
        isLoaded.value = _isLoaded;
    };

    /** Set 停止登入Id */
    const setCurrentAlertId = (_id: string) => {
        currentAlertId.value = _id;
    };

    /** Set 確認 停止登入Id */
    const setConfirmedAlertId = (_id: string) => {
        confirmedAlertId.value = _id;
    };

    return {
        $reset,
        routeInitState,
        setRouteInit,
        isLogin,
        setLoginState,
        isMobile,
        setIsMobileState,
        isWebView,
        setIsWebViewState,
        isLoaded,
        setIsLoaded,
        currentAlertId,
        setCurrentAlertId,
        confirmedAlertId,
        setConfirmedAlertId
    };
});
